/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_To_Our_Private_CollectInputs */

const en_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to our private collection...`)
};

const es_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido a nuestra colección privada...`)
};

const fr_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue dans notre collection privée...`)
};

const de_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen in unserer privaten Kollektion...`)
};

const ja_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちのプライベートコレクションへようこそ...`)
};

const zh_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎来到我们的私人收藏...`)
};

const ar_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحباً بكم في مجموعتنا الخاصة...`)
};

const id_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selamat datang di koleksi pribadi kami...`)
};

const it_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto nella nostra collezione privata...`)
};

const ru_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать в нашу частную коллекцию...`)
};

const pt_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo à nossa coleção privada...`)
};

const ko_welcome_to_our_private_collect = /** @type {(inputs: Welcome_To_Our_Private_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저희 프라이빗 컬렉션에 오신 것을 환영합니다...`)
};

/**
* | output |
* | --- |
* | "Welcome to our private collection..." |
*
* @param {Welcome_To_Our_Private_CollectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const welcome_to_our_private_collect = /** @type {((inputs?: Welcome_To_Our_Private_CollectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_To_Our_Private_CollectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_to_our_private_collect(inputs)
	if (locale === "es") return es_welcome_to_our_private_collect(inputs)
	if (locale === "fr") return fr_welcome_to_our_private_collect(inputs)
	if (locale === "de") return de_welcome_to_our_private_collect(inputs)
	if (locale === "ja") return ja_welcome_to_our_private_collect(inputs)
	if (locale === "zh") return zh_welcome_to_our_private_collect(inputs)
	if (locale === "ar") return ar_welcome_to_our_private_collect(inputs)
	if (locale === "id") return id_welcome_to_our_private_collect(inputs)
	if (locale === "it") return it_welcome_to_our_private_collect(inputs)
	if (locale === "ru") return ru_welcome_to_our_private_collect(inputs)
	if (locale === "pt") return pt_welcome_to_our_private_collect(inputs)
	return ko_welcome_to_our_private_collect(inputs)
});